// Path: ./src/app/components/AccountsPageLayout/index.tsx
import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { AccountSideBarDrawer } from "../AccountSidebarDrawer";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import { IsAuthenticated } from "../../../utils/IsAuthenticated";
import { Navigate } from "react-router-dom";
import { SUPERADMIN } from "../../../utils/constant/stringConstant";
import { GoFlyerAdminContext } from "../../../contextApi/context";
import { routes } from "../../../utils/constant/navigationRoutes";
const drawerWidth = 260;

interface Props {
  window?: () => Window;
  children: React.ReactNode;
  // linkList: {
  //   title: string;
  //   listItems: { linkPath: string; linkText: string }[];
  // }[];
}

export default function AccountPageLayout(props: Props) {
  const { children } = props;
  const { t } = useTranslation();
  const { state } = React.useContext(GoFlyerAdminContext);

  const linkList = [
    {
      title: `${t(messages.Accounts())}`,
      dataTestId: "accounts-button",
      roleName: ["view"],
      groupName: ["user", "role"],
      listItems: [
        {
          linkPath: routes.user.view,
          linkText: `${t(messages.User())}`,
          dataTestId: "user-view-button",
          roleName: ["view"],
          groupName: ["user"],
        },
        {
          linkPath: routes.role.view,
          linkText: `${t(messages.Role())}`,
          dataTestId: "role-view-button",
          roleName: ["view"],
          groupName: ["role"],
        },
        {
          linkPath: routes.permission.view,
          linkText: `${t(messages.Permission())}`,
          dataTestId: "permission-view-button",
          roleName: ["view"],
          groupName: ["user"],
        },
      ],
    },
    {
      title: `${t(messages.Merchant())}`,
      dataTestId: "merchants-button",
      roleName: ["view"],
      groupName: ["merchant", "store"],
      listItems: [
        {
          linkPath: routes.merchant.view,
          linkText: `${t(messages.Merchant())}`,
          dataTestId: "merchant-view-button",
          roleName: ["view"],
          groupName: ["merchant"],
        },
        {
          linkPath: routes.store.view,
          linkText: `${t(messages.stores())}`,
          dataTestId: "store-view-button",
          roleName: ["view"],
          groupName: ["store"],
        },
      ],
    },
    {
      title: `${t(messages.Image())}`,
      dataTestId: "image-button",
      linkPath: routes.image.view,
      groupName: ["image"],
      roleName: ["view"],
    },
    {
      title: `${t(messages.Unit())}`,
      dataTestId: "unit-button",
      linkPath: routes.unit.view,
      groupName: ["unit"],
      roleName: ["view"],
    },
    {
      title: `${t(messages.Tags())}`,
      dataTestId: "tags-button",
      linkPath: routes.tag.view,
      groupName: ["tag"],
      roleName: ["view"],
    },
    {
      title: `${t(messages.Deal_Spotlights())}`,
      dataTestId: "deal-spotlights-button",
      linkPath: routes.dealSpotlights.view,
      groupName: ["deals"],
      roleName: ["view"],
    },
    {
      title: `${t(messages.preference_cuisines())}`,
      dataTestId: "preference-cuisine-button",
      linkPath: routes.preferenceCuisine.view,
      groupName: ["tag"],
      roleName: ["view"],
    },
    {
      title: `${t(messages.preference_watch_items())}`,
      dataTestId: "preference-watch-item-button",
      linkPath: routes.preferenceWatchItem.view,
      groupName: ["tag"],
      roleName: ["view"],
    },
    {
      title: `${t(messages.Notifications())}`,
      dataTestId: "notification-button",
      linkPath: routes.notification.view,
      groupName: ["notification"],
      roleName: ["view"],
    },
    {
      title: `Flyer Scraper Source`,
      dataTestId: "flyerScraper-button",
      linkPath: routes.flyerScraper.view,
      groupName: ["flyerScraper"],
      roleName: ["view"],
    },

    {
      title: `${t(messages.ELASTIC_TRIGGER())}`,
      dataTestId: "ElasticTrigger-button",
      linkPath: routes.elasticTrigger.view,
      groupName: ["elasticTrigger"],
      roleName: ["view"],
    },
    {
      title: ` ${t(messages.CACHE())}`,
      dataTestId: "cache-button",
      linkPath: routes.cache.view,
      groupName: ["cache"],
      roleName: ["view"],
    },
    {
      title: `${t(messages.FEEDBACK())}`,
      dataTestId: "feedBack-button",
      linkPath: routes.feedback.view,
      groupName: ["feedback"],
      roleName: ["view"],
    },
    {
      title: `${t(messages.Figma_Templates())}`,
      dataTestId: "Figma-Template-button",
      linkPath: routes.figmaTemplate.view,
      groupName: ["figmaTemplates"],
      roleName: ["view"],
    },
    {
      title: `${t(messages.Banner())}`,
      dataTestId: "banner-button",
      linkPath: routes.banner.view,
      groupName: ["banner"],
      roleName: ["view"],
    },
    {
      title: `${t(messages.Figma_Component_Layout())}`,
      dataTestId: "Figma-Component-Layout-button",
      linkPath: routes.figma.view,
      groupName: ["figmaComponentLayout"],
      roleName: ["view"],
    },
    {
      title: `${t(messages.Figma_Health_Monitoring())}`,
      dataTestId: "Figma-health-button",
      linkPath: routes.figmaHealthMonitor.view,
      groupName: ["figmaHealthMonitoring"],
      roleName: ["view"],
    },
    {
      title: `Database Driven Variables`,
      dataTestId: "database-driven-variables-button",
      linkPath: routes.variables.view,
      groupName: ["variables"],
      roleName: ["view"],
    },
    {
      title: `Email Notifications`,
      dataTestId: "email-notifications-button",
      linkPath: routes.emailNotifications.view,
      groupName: ["variables"],
      roleName: ["view"],
    },
    {
      title: `Shopping List Report`,
      dataTestId: "shopping-list-report-button",
      linkPath: routes.shoppingListReport.view,
      groupName: ["shoppingListReport"],
      roleName: ["view"],
    },
    {
      title: t(messages.RecommendationEngine_Title()),
      dataTestId: "recommendation-engine-button",
      linkPath: routes.recommendationEngine.view,
      groupName: ["recommendationEngine"],
      roleName: ["view"],
    },
    {
      title: t(messages.Analytics_Title()),
      dataTestId: "analytics-button",
      linkPath: routes.analytics.view,
      groupName: ["analytics"],
      roleName: ["view"],
    },

    {
      title: t(messages.Admin_Settings_Catalog()),
      dataTestId: "adminSettingCatalog-button",
      linkPath: "/adminSettingCatalog/view",
      groupName: ["adminSettingCatalog"],
      roleName: ["view"],
    },
  ];
  if (!IsAuthenticated()) {
    return (
      <Navigate
        to={routes.core.login}
        replace
        data-testid="rolebaseaccessroute-test-id"
      />
    );
  }
  if (
    state.user?.parsedRoles?.name === SUPERADMIN &&
    !state.gfAdminUser?.settingsPage
  ) {
    return <Navigate to={routes.core.dashboard} replace />;
  }
  return (
    <Box sx={{ display: "flex" }} data-testid="accountpagelayout-test-id">
      <CssBaseline />
      <AccountSideBarDrawer linkList={linkList} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1, sm: 3 },
          width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
